import React, { useState, useEffect } from "react";
import { Wheel } from "react-custom-roulette";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  Box,
  Grid,
  Typography,
} from "@mui/material";
import confetti from "canvas-confetti";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import axios from "axios"; // Import Axios
import { api_url } from "./../../../apiUtils";
import { useAppStore } from "../../../appStore";
import Slide from "@mui/material/Slide";
import Fade from "@mui/material/Fade";
import Grow from "@mui/material/Grow";
import { getDeviceId } from "../../utils/DeviceId";
import { pingGameSession } from "../../utils/GameServices";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const RandomNumberWheel = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [mustSpin, setMustSpin] = useState(false);
  const [prizeNumber, setPrizeNumber] = useState(0);
  const [didWin, setDidWin] = useState(false);
  const [selectedNumber, setSelectedNumber] = useState(1);
  const [amount, setAmount] = useState(5);
  const [disabled, setDisabled] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const deviceId = getDeviceId();
  const [resultData, setResultData] = useState(null);
  const [showSpinButton, setShowSpinButton] = useState(true);
  const {
    setWalletBalance,
    profileData,
    spinMinute,
    setSpinMinute,
    spinTimerId,
    spinTimerStartedAt,
    setSpinTimerId,
    setSpinTimerStartedAt,
  } = useAppStore();
  const [gameSettings, setGameSettings] = useState({
    dice: { forcedWinCycleCount: null, winningRatio: null },
    spin: { forcedWinCycleCount: null, winningRatio: null },
    direction: { forcedWinCycleCount: null, winningRatio: null },
  });
  const [loadingResult, setLoadingResult] = useState(false);
  const sessionToken = sessionStorage.getItem("sessionId");

  const numberRange = 7; // Fixed range of numbers

  useEffect(() => {
    generateData();
  }, []);

  const generateData = () => {
    const numbers = [];
    for (let i = 1; i <= numberRange; i++) {
      const backgroundColor = i % 2 === 0 ? "#FFD700" : "#6A3C99";
      numbers.push({
        option: i.toString(),
        style: { backgroundColor, textColor: "#ffffff" },
      });
    }
    setData(numbers);
    setResultData(null);
  };

  const colorfulNumbersData = [
    { option: "1", style: { backgroundColor: "#D32F2F" } },
    { option: "2", style: { backgroundColor: "#1976D2" } },
    { option: "3", style: { backgroundColor: "#388E3C" } },
    { option: "4", style: { backgroundColor: "#F57C00" } },
    { option: "5", style: { backgroundColor: "#7B1FA2" } },
    { option: "6", style: { backgroundColor: "#0097A7" } },
    { option: "7", style: { backgroundColor: "#FFA000" } },
  ];

  const wheelData = colorfulNumbersData.map((item) => ({
    option: item.option,
    style: {
      backgroundColor: item.style.backgroundColor,
    },
    text: item.option,
  }));

  const handleSpinClick = async () => {
    setLoadingResult(true);
    if (!selectedNumber || !amount) {
      toast.warning("Please select a number and enter an amount!");
      return;
    }
    setShowSpinButton(false);

    try {
      setDisabled(true);
      // Call API to get result
      const response = await axios.post(
        `${api_url}game/spin-and-win`,
        {
          userId: profileData?._id,
          chosenNumber: selectedNumber,
          betAmount: amount,
        },
        {
          headers: {
            accesstoken: sessionStorage.getItem("accesstoken"),
          },
        }
      );

      const { success, didWin, winAmount, outcome, balance, spunNumber } =
        response.data;

      if (success) {
        // Find the index in wheelData that matches spunNumber as string (wheelData option is string)
        const prizeIndex = wheelData.findIndex(
          (item) => parseInt(item?.option) === spunNumber
        );

        setPrizeNumber(prizeIndex);
        setDidWin(didWin);

        // setPrizeNumber(index);
        setMustSpin(true);

        // Update wallet balance locally

        // Store result for later use
        setResultData({
          status: outcome,
          rolled: Number(spunNumber),
          winAmount,
          balance,
        });
      } else {
        toast.error("Spin failed. Please try again.");
      }
      setLoadingResult(true);
    } catch (error) {
      console.error("Spin API failed:", error);
      toast.error(error?.response?.data?.message || "Spin failed. Please try again.");
      setDisabled(false);
      setLoadingResult(true);
    } finally {
      setLoadingResult(false);
    }
  };

  const handleResult = () => {
    if (resultData?.status === "win") fireConfetti();

    // 👇 Use requestAnimationFrame to prevent premature re-renders
    requestAnimationFrame(() => {
      setOpenDialog(true);
      // setDisabled(false);
    });

    // 👇 Delay mustSpin false until fully settled visually (longer delay)
    setTimeout(() => {
      setMustSpin(false);
      // setDisabled(false);
    }, 1200); // ← this delay should be longer than spinDuration

    setTimeout(() => {
      setWalletBalance(resultData?.balance);
    }, 1400);
  };

  const fireConfetti = () => {
    const duration = 2000;
    const animationEnd = Date.now() + duration;
    const defaults = {
      startVelocity: 30,
      spread: 360,
      ticks: 60,
      zIndex: 1000,
    };

    const randomInRange = (min, max) => Math.random() * (max - min) + min;

    const interval = setInterval(() => {
      const timeLeft = animationEnd - Date.now();
      if (timeLeft <= 0) return clearInterval(interval);

      confetti({
        ...defaults,
        particleCount: 50,
        origin: {
          x: randomInRange(0.1, 0.9),
          y: Math.random() - 0.2,
        },
      });
    }, 200);
  };

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await axios.get(`${api_url}auth/get-auto-game-settings`, {
          headers: {
            accessToken: sessionStorage.getItem("accesstoken"),
          },
        });

        const data = res.data.data;

        const newSettings = {
          dice: { forcedWinCycleCount: 0, winningRatio: 0 },
          spin: { forcedWinCycleCount: 0, winningRatio: 0 },
          direction: { forcedWinCycleCount: 0, winningRatio: 0 },
        };

        data.forEach((s) => {
          if (s.key === "dice") {
            newSettings.dice = {
              forcedWinCycleCount: s.forcedWinCycleCount,
              winningRatio: s.winningRatio,
            };
          } else if (s.key === "spin") {
            newSettings.spin = {
              forcedWinCycleCount: s.forcedWinCycleCount,
              winningRatio: s.winningRatio,
            };
            setSpinMinute(s.minutes);
          } else if (s.key === "direction") {
            newSettings.direction = {
              forcedWinCycleCount: s.forcedWinCycleCount,
              winningRatio: s.winningRatio,
            };
          }
        });

        setGameSettings(newSettings);
      } catch (err) {
        console.error("Failed to load auto game settings", err);
      }
    };

    fetchSettings();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      pingGameSession("spin-and-win");
    }, 2 * 60 * 1000); // every 2 mins

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    startDiceTimer();
    return () => clearTimeout(spinTimerId);
  }, []); // runs only once on mount
  console.log("minute", spinMinute);
  function startDiceTimer() {
    const delay = (spinMinute || 5) * 60 * 1000;
    const now = Date.now();

    // If timer already started, compute remaining
    if (spinTimerStartedAt) {
      const elapsed = now - spinTimerStartedAt;
      const remaining = delay - elapsed;

      if (remaining > 0) {
        console.log(`⏱️ Resuming dice timer with ${remaining / 1000}s left`);
        const timeoutId = setTimeout(callUpdateCycle, remaining);
        setSpinTimerId(timeoutId);
        return;
      }
    }

    console.log(
      `⏱️ Starting new dice cycle timer for ${delay / 60000} minutes`
    );
    const timeoutId = setTimeout(callUpdateCycle, delay);
    setSpinTimerId(timeoutId);
    setSpinTimerStartedAt(now);
  }

  async function callUpdateCycle() {
    try {
      console.log("⏰ Timer reached! Calling update-dice-cycle API...");
      await axios.put(
        `${api_url}game/update-spin-cycle`,
        {
          userId: profileData?._id,
          deviceId,
          sessionToken,
        },
        {
          headers: { accesstoken: sessionStorage.getItem("accesstoken") },
        }
      );
      console.log("✅ update-dice-cycle API called successfully");

      // 🔁 Restart timer for next cycle automatically
      setSpinTimerStartedAt(Date.now());
      startDiceTimer();
    } catch (error) {
      console.error("❌ Error calling update-dice-cycle API:", error);
    }
  }

  // ✅ Preload images once to prevent flicker
  useEffect(() => {
    const preload = (src) => {
      const img = new Image();
      img.src = src;
    };
    preload("/youwin.png");
    preload("/auto-games/betterluck.webp");
  }, []);

  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <ArrowBackIcon
          sx={{
            color: "#fff",
            border: "1px solid #fff",
            backgroundColor: "transparent",
            borderRadius: 2,
            "&:hover": { backgroundColor: "#1e2466", color: "#fff" },
            cursor: "pointer",
          }}
          onClick={async () => {
            try {
              await axios.post(
                `${api_url}game/extra-game/end-session`,
                {
                  gameId: "spin-and-win",
                  deviceId: getDeviceId(),
                  sessionToken: sessionStorage.getItem("sessionId"),
                },
                {
                  headers: {
                    accesstoken: sessionStorage.getItem("accesstoken"),
                  },
                }
              );

              // After session ends, navigate back
              navigate("/home/menus");
            } catch (err) {
              console.error("Failed to end session on back", err);
              navigate("/home/menus"); // Fallback navigation
            }
          }}
        />
        <Typography
          sx={{
            fontWeight: "bold",
            fontSize: { xs: "20px", md: "24px" },
            ml: 1,
            color: "#fff",
          }}
        >
          SPIN & WIN [ 1 : {gameSettings.spin.winningRatio} ]
        </Typography>
      </Box>

      {data.length > 0 && (
        <>
          {/* Container for the entire layout */}
          <Box
            sx={{
              maxWidth: 900,
              mx: "auto",
              px: 2,
            }}
          >
            {/* Mobile: SpinWin text on top */}
            <Box
              sx={{
                display: { xs: "flex", sm: "none" },
                justifyContent: "center",
                mb: 3,
                width: "100%",
                height: 100,
              }}
            >
              <img
                src="/spin-win/text_1.webp"
                alt="SpinWin Text"
                style={{ width: "100%", maxWidth: 200, objectFit: "contain" }}
              />
            </Box>

            {/* Text fields container */}
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "row", sm: "row" },
                justifyContent: "center",
                gap: 1,
              }}
            >
              <TextField
                select
                label="Choose a Number"
                value={selectedNumber}
                onChange={(e) => {
                  if (!mustSpin) {
                    setSelectedNumber(e.target.value);
                  }
                }}
                variant="outlined"
                size="small"
                sx={{
                  width: { xs: 100, sm: 150 },
                  pointerEvents: mustSpin ? "none" : "auto", // ← disables interaction
                  "& .MuiInputBase-root": {
                    height: 50,
                    color: "#FFD80A",
                    background: "rgba(255, 255, 255, 0.1)",
                    borderRadius: 1,
                    fontSize: { xs: "1.3rem", sm: "2rem" },
                    textAlign: "center",
                    fontWeight: "bolder",
                  },
                  "& .MuiInputLabel-root": { color: "#FFD80A" },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#FFD80A",
                  },
                  "& option": { color: "#000", fontSize: "0.9rem" },
                  "& .MuiInputBase-input": { textAlign: "center" },
                }}
                SelectProps={{
                  native: true,
                  sx: { color: "black" },
                }}
                InputLabelProps={{ shrink: true }}
                disabled={openDialog}
              >
                {data.map((item, index) => (
                  <option key={index} value={item.option}>
                    {item.option}
                  </option>
                ))}
              </TextField>

              <TextField
                label="Amount"
                value={amount}
                variant="outlined"
                size="small"
                sx={{
                  width: { xs: 100, sm: 150 },
                  "& .MuiInputBase-root": {
                    height: 50,
                    color: "#FFD80A",
                    background: "rgba(255, 255, 255, 0.1)",
                    borderRadius: 1,
                    fontSize: { xs: "1.3rem", sm: "2rem" },
                    textAlign: "center",
                    fontWeight: "bolder",
                  },
                  "& .MuiInputLabel-root": { color: "#FFD80A" },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#FFD80A",
                  },
                  "& .MuiInputBase-input": { textAlign: "center" },
                }}
                InputProps={{ readOnly: true }}
              />
            </Box>

            {/* Mobile: Wheel below text fields */}
            <Box
              sx={{
                display: { xs: "flex", sm: "none" },
                justifyContent: "center",
                my: 3,
              }}
            >
              <Wheel
                mustStartSpinning={mustSpin}
                prizeNumber={prizeNumber}
                data={wheelData}
                backgroundColors={["#8E24AA", "#BA68C8", "#F3E5F5"]}
                textColors={["#ffffff"]}
                outerBorderColor="#fff"
                outerBorderWidth={5}
                innerRadius={10}
                radiusLineColor="#ffffff"
                radiusLineWidth={1}
                fontSize={36}
                spinDuration={0.3}
                onStopSpinning={handleResult}
                style={{ maxWidth: 280, width: "100%" }}
              />
            </Box>

            {/* Mobile: Spin Button below wheel */}
            {showSpinButton && (
              <Box
                sx={{
                  display: { xs: "flex", sm: "none" },
                  justifyContent: "center",
                  cursor: disabled ? "not-allowed" : "pointer",
                  opacity: disabled ? 0.5 : 1,
                  transition: "transform 0.2s ease-in-out",
                  "&:hover": {
                    transform: disabled ? "none" : "scale(1.05)",
                  },
                  mx: "auto",
                }}
                onClick={handleSpinClick}
                component="img"
                src="/spin-win/spinbtn.webp"
                alt="Spin Button"
                width={140}
              />
            )}

            {/* Desktop and tablet: SpinWin text + Wheel + Spin button in one row */}
            <Box
              sx={{
                display: { xs: "none", sm: "flex" },
                alignItems: "center",
                justifyContent: "center",
                gap: 4,
                mt: 1,
              }}
            >
              <Box
                sx={{
                  width: 200,
                  height: 150,
                  flexShrink: 0,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <img
                  src="/spin-win/text_1.webp"
                  alt="SpinWin Text"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              </Box>

              <Box
                sx={{
                  width: 350,
                  flexShrink: 0,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Wheel
                  mustStartSpinning={mustSpin}
                  prizeNumber={prizeNumber}
                  data={wheelData}
                  backgroundColors={["#8E24AA", "#BA68C8", "#F3E5F5"]}
                  textColors={["#ffffff"]}
                  outerBorderColor="#fff"
                  outerBorderWidth={5}
                  innerRadius={10}
                  radiusLineColor="#ffffff"
                  radiusLineWidth={1}
                  fontSize={36}
                  spinDuration={0.3}
                  onStopSpinning={handleResult}
                />
              </Box>

              {showSpinButton ? (
                <Box
                  sx={{
                    flexShrink: 0,
                    cursor: disabled ? "not-allowed" : "pointer",
                    opacity: disabled ? 0.5 : 1,
                    transition: "transform 0.2s ease-in-out",
                    "&:hover": {
                      transform: disabled ? "none" : "scale(1.05)",
                    },
                    display: "flex",
                    justifyContent: "center",
                    ml: 4,
                  }}
                  onClick={handleSpinClick}
                  component="img"
                  src="/spin-win/spinbtn.webp"
                  alt="Spin Button"
                  width={140}
                />
              ) : (
                <Box
                  sx={{
                    flexShrink: 0,
                    cursor: disabled ? "not-allowed" : "pointer",
                    opacity: disabled ? 0.5 : 1,
                    transition: "transform 0.2s ease-in-out",
                    "&:hover": {
                      transform: disabled ? "none" : "scale(1.05)",
                    },
                    display: "flex",
                    justifyContent: "center",
                    ml: 4,
                  }}
                  onClick={handleSpinClick}
                  width={140}
                />
              )}
            </Box>
          </Box>
        </>
      )}

      <Dialog
        open={openDialog}
        TransitionComponent={Transition}
        keepMounted
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: {
            borderRadius: 3,
            background: "linear-gradient(90deg,rgb(94, 15, 151), #9b30ff)",
            boxShadow: 10,
            border: `6px solid #4b0082`,
          },
        }}
      >
        <Fade in={openDialog} timeout={500}>
          <DialogTitle
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: 0,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mt: 2,
                  mb: 3,
                }}
              >
                <Grow in={openDialog} timeout={600}>
                  <Box
                    sx={{
                      height: { xs: "80px", sm: "100px" },
                      width: "150px",
                    }}
                  >
                    <img
                      key={didWin ? "win" : "lose"}
                      src={
                        didWin ? "/youwin.png" : "/auto-games/betterluck.webp"
                      }
                      alt="Dice Roll Logo"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        display: "block",
                      }}
                    />
                  </Box>
                </Grow>
              </Box>
            </Box>
          </DialogTitle>
        </Fade>

        <DialogContent sx={{ p: 0, textAlign: "center" }}>
          <Grid container spacing={2}>
            {[selectedNumber, resultData?.rolled].map((value, index) => (
              <Grid item xs={6} key={index}>
                <Grow in={openDialog} timeout={700 + index * 150}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      mb: 3,
                    }}
                  >
                    <Box sx={{ width: "70px" }}>
                      <img
                        src={index === 0 ? "/selected.png" : "/totalscore.png"}
                        alt={index === 0 ? "Selected" : "Total Score"}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                          display: "block",
                        }}
                      />
                    </Box>
                    <Box
                      sx={{
                        mt: 2,
                        width: 80,
                        height: 80,
                        background:
                          // index === 0
                          //   ? "linear-gradient(45deg, #7b68ee, #9b30ff)"
                          //   : selectedNumber === resultData?.rolled
                          //   ? "linear-gradient(45deg, #7b68ee, #9b30ff)"
                          // :
                          "linear-gradient(45deg, #ff4d4d,rgb(163, 16, 163))",
                        borderRadius: "50%",
                        color: "white",
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "1.5rem",
                        boxShadow: 3,
                      }}
                    >
                      {value}
                    </Box>
                  </Box>
                </Grow>
              </Grid>
            ))}
          </Grid>

          <Grow in={openDialog} timeout={1000}>
            <Button
              variant="outlined"
              align="center"
              sx={{
                mx: { xs: 5, sm: 10 },
                mt: 2,
                fontWeight: "bold",
                letterSpacing: 0.5,
                color: "#fff",
                borderColor: "#fff",
                background: didWin
                  ? "linear-gradient(90deg, #7b68ee, #9b30ff)"
                  : "linear-gradient(90deg, #ff4d4d, #800080)",
                "&:hover": {
                  opacity: 0.85,
                  background: didWin
                    ? "linear-gradient(90deg, #7b68ee, #a64dff)"
                    : "linear-gradient(90deg, #ff6666, #9932cc)",
                },
              }}
            >
              {didWin ? (
                <>
                  You earned{" "}
                  <Box
                    component="span"
                    sx={{
                      fontSize: "1.3rem",
                      fontWeight: "900",
                      background: "linear-gradient(45deg, #00ff00, #00cc00)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      display: "inline-block",
                      mx: 1,
                    }}
                  >
                    {resultData?.winAmount}
                  </Box>
                  credits
                </>
              ) : (
                <>
                  You lost{" "}
                  <Box
                    component="span"
                    sx={{ fontSize: "1.3rem", fontWeight: "900", mx: 1 }}
                  >
                    {amount}
                  </Box>
                  credits
                </>
              )}
            </Button>
          </Grow>
        </DialogContent>

        <DialogActions sx={{ px: 3 }}>
          <Grow in={openDialog} timeout={1200}>
            <Button
              onClick={() => {
                setOpenDialog(false);
                setShowSpinButton(true);
                setDisabled(false);
              }}
              fullWidth
              sx={{
                "&:hover": {
                  backgroundColor: "transparent",
                  opacity: 1,
                },
                backgroundColor: "transparent",
              }}
            >
              <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
                <Box sx={{ width: "220px" }}>
                  <img
                    src={didWin ? "/playagain.png" : "/tryagain.png"}
                    alt="Play Again"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      display: "block",
                    }}
                  />
                </Box>
              </Box>
            </Button>
          </Grow>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default RandomNumberWheel;
